import { RelationSetDest, RelationSetDestAttribute } from "../api/graphqlTyped/RelationSetDest";
import { StoreBase } from "../cutil/StoreBase";
import { tryPromise } from "../cutil/LangUtil";
import { JsonUtil } from "../cutil/JsonUtil";
import { ArrayUtil } from "../util/ArrayUtil";
import isBlank from "@sedan-utils/is-blank";
import { Lazyload } from "../cutil/Lazyload";
export class PersonalFunctionStore extends StoreBase {
    constructor(brainClient) {
        super(() => []);
        this.brainClient = brainClient;
        this.lazyload = new Lazyload(() => {
            if (this.state.length !== 0) {
                /// 已从fot收到数据，无需自己调api
                return Promise.resolve(this.state);
            }
            return this.getFunctions(1, []).then(data => {
                const res = data
                    .map(element => {
                    const attri = element.attributesV2;
                    if (attri) {
                        attri.destId = element.id;
                    }
                    return attri;
                })
                    .filter(element => {
                    return element !== undefined;
                });
                this.emit(res);
                return res;
            });
        });
        this.extractFunctions = [];
    }
    receive(userFunctions) {
        if (userFunctions == undefined || userFunctions.length === 0) {
            return;
        }
        const relationSetDests = JsonUtil.toArrayFromType(RelationSetDest, userFunctions) || [];
        const relationSetDestAttributes = relationSetDests
            .map(e => {
            const attri = e.attributesV2;
            if (attri) {
                attri.destId = e.id;
            }
            return attri;
        })
            .filter(e => e !== undefined);
        const nonRepetitive = this.state.filter(element => {
            return !ArrayUtil.contains(relationSetDestAttributes, element, r => {
                if (element.destId !== undefined && r.destId !== undefined) {
                    return r.destId;
                }
                return r.name;
            });
        });
        const newArr = nonRepetitive.concat(relationSetDestAttributes);
        this.lazyload.dirty();
        this.emit(newArr);
    }
    clean() {
        this.lazyload.dirty();
        this.emit([]);
    }
    async get() {
        const apiData = await this.lazyload.get();
        const newData = [...apiData, ...this.extractFunctions];
        return newData;
    }
    syncGet() {
        return [...this.state, ...this.extractFunctions];
    }
    extractFuncs(project) {
        let functions;
        if (!isBlank(project?.attributes?.v2)) {
            functions = project?.attributes?.v2?.functions;
        }
        if (!isBlank(project?.attributes?.v3)) {
            functions = project?.attributes?.v3?.functions;
        }
        const funcs = functions
            ?.filter(element => {
            return element !== undefined;
        })
            .map(f => {
            return JsonUtil.toModelFromType(RelationSetDestAttribute, f);
        })
            .filter(f => f !== undefined);
        this.extractFunctions = [...this.extractFunctions, ...funcs];
        this.extractFunctions = ArrayUtil.deDuplication(this.extractFunctions, item => {
            return item.name;
        });
    }
    async findDest(params) {
        const functions = await this.get();
        const findById = functions.find(dest => {
            return params.funcId && dest.destId === params.funcId;
        });
        if (findById) {
            return findById;
        }
        const findByValue = functions.find(dest => {
            return params.funcValue && dest.name === params.funcValue;
        });
        if (findByValue) {
            return findByValue;
        }
        const cleanName = params.edgeName.replace("/", "");
        const findByName = functions.find(dest => {
            return dest.name === cleanName;
        });
        if (findByName) {
            return findByName;
        }
        return undefined;
    }
    async getFunctions(page, completionResult) {
        const size = 20;
        const res = await this.requestFunctions(page, size);
        const newResult = [...completionResult, ...res];
        if (res.length < size) {
            return newResult;
        }
        return this.getFunctions(page + 1, newResult);
    }
    async requestFunctions(page, size) {
        const tryRes = await tryPromise(this.brainClient.graphql.getPersonalFunctions({
            name: "studio_function",
            page: page,
            size: size,
        }));
        if (tryRes.error) {
            console.error(tryRes.error);
        }
        return tryRes.data?.data || [];
    }
}
